import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { getNotificationDestination, openNotificationDestination } from '../../utils/navigation';
import Header from '../layout/Header';

export default function NotificationSingle() {
  const location = useLocation();
  const navigate = useNavigate();

  const { notification } = location.state || {};
  const content = notification?.content || notification?.notification_content || {};
  const actionUrl = getNotificationDestination(notification);

  if (!notification) {
    return (
      <Typography variant="h6" color="error">
        Notifica non trovata.
      </Typography>
    );
  }

  return (
    <Box sx={{ p: 2, mx: 'auto', mt: 'var(--cv-top-bar-height)' }}>
      <Header title="Dettaglio notifica" />
      <Box sx={{ my: 3 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          {content.title}
        </Typography>
        <Typography variant="body1" color="textSecondary" sx={{ mb: 2 }}>
          {content.body || content.message}
        </Typography>
        {actionUrl && (
          <Button
            variant="contained"
            onClick={() => openNotificationDestination(navigate, actionUrl)}
            sx={{ mt: 1 }}
          >
            {content.linkLabel || 'Apri'}
          </Button>
        )}
      </Box>
    </Box>
  );
}
